const b = require('app/www/libs/b')('program-multichannels');

const React = require('react');
const PropTypes = require('prop-types');
const ProgramSchedule = require('app/www/components/blocks/ProgramSchedule/ProgramSchedule');
const CollapseList = require('app/www/components/blocks/CollapseList/CollapseList');
const ChannelSnippet = require('app/www/components/blocks/ChannelSnippet/ChannelSnippet');
const Metrika = require('app/www/libs/client/metrika');
const _ = {
    get: require('lodash/get'),
    cloneDeep: require('lodash/cloneDeep'),
};

class ProgramMultichannels extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            update: false,
        };

        this._onToggle = this._onToggle.bind(this);
        this._onToggleItem = this._onToggleItem.bind(this);
    }

    componentDidMount() {
        const schedules = this.props.schedules.filter(item => Object.keys(item.schedule).length > 0);
        const schedule = schedules[0];

        if (schedule) {
            Metrika.trackParams('PROGRAM_PAGE', {
                action: 'show',
                component: 'channel_blocks',
                type: `length_${schedules.length}`,
                orderIndex: 1,
                channelId: _.get(schedule, 'channel.id', ''),
                programId: _.get(schedule, 'metrika.programId', ''),
            });
        }
    }

    render() {
        const {isTouchButtons} = this.props;
        const schedules = this.props.schedules.filter(item => Object.keys(item.schedule).length > 0);
        const programScheduleProps = {
            isTouchButtons,
            onToggleItem: this._onToggleItem,
        };

        return (
            <div className={b()}>
                <CollapseList
                    items={schedules.map(item => {
                        item.schedule = _.cloneDeep(item.schedule);

                        return {
                            id: item.channel.id,
                            orderIndex: item.metrika.orderIndex,
                            header: (<ChannelSnippet key={item.channel.id} {...item.channel} />),
                            description: (<ProgramSchedule key={item.channel.id} {...item} {...programScheduleProps} />),
                        };
                    })}
                    openedItemId={_.get(schedules, '0.channel.id')}
                    openMultiple={true}
                    onToggle={this._onToggle}
                    mods={{multichannel: true}}
                />
            </div>
        );
    }

    _onToggle(channelId, orderIndex, isOpen) {
        const {schedules} = this.props;

        Metrika.trackParams('PROGRAM_PAGE', {
            action: 'click',
            component: 'channel_blocks',
            type: isOpen ? 'block_unfold' : 'block_fold',
            orderIndex,
            channelId,
            programId: schedules[0].metrika.programId,
        });
    }

    _onToggleItem() {
        this.setState({
            update: !this.state.update,
        });
    }
}

ProgramMultichannels.propTypes = {
    schedules: PropTypes.array.isRequired,
    isTouchButtons: PropTypes.bool,
};

module.exports = ProgramMultichannels;
